module.exports = __webpack_public_path__ + "static/img/bg-13.936b4c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-13.png
// module id = h6j2
// module chunks = 0